import React from 'react';
import { motion } from 'framer-motion';
import AnimatedBadge from '../ui/AnimatedBadge';

export default function TimelineSection() {
  const milestones = [
    { 
      date: "13 Mar 1969", 
      title: "O Início", 
      desc: "Fundação da Etesco Escritório Técnico Contábil. Nascia um compromisso com a honestidade e a técnica." 
    },
    { 
      date: "01 Dez 2015", 
      title: "Cisão & JWCosta", 
      desc: "Nascimento da JWCosta Soluções Contábeis. Um novo conceito herdando 50 anos de história." 
    },
    { 
      date: "16 Mar 2020", 
      title: "Desafio Status Quo", 
      desc: "Pandemia: mudamos nossa maneira de pensar. Deixamos de ser tradicionais para sermos digitais e centrados em pessoas." 
    },
    { 
      date: "21 Set 2021", 
      title: "Legado Eterno", 
      desc: "Despedida do nosso fundador José Walter da Costa. Sua chama de empreendedorismo permanece viva em nós." 
    },
    { 
      date: "01 Mar 2023", 
      title: "Nova Era", 
      desc: "Renascimento da marca com foco total em integração (Thomson Reuters) e inteligência de dados." 
    }
  ];

  return (
    <section id="timeline" className="w-full bg-background py-24 border-t border-foreground/5 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-32">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-6"
          >
            <AnimatedBadge>
              Nossa Jornada Até Aqui
            </AnimatedBadge>
          </motion.div>
          <h2 className="text-4xl md:text-5xl font-black text-foreground tracking-tight mb-6 leading-[1.4]">
            Esculpindo o Futuro <br /> desde 1969.
          </h2>
        </div>

        {/* Horizontal Timeline Container */}
        <div className="relative">
          {/* Main Horizontal Line */}
          <div className="absolute top-[40px] left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-orange-500/30 to-transparent hidden lg:block"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-6">
            {milestones.map((item, idx) => (
              <motion.div 
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: idx * 0.1 }}
                className="relative flex flex-col items-center lg:items-start text-center lg:text-left group"
              >
                {/* Visual Dot on Line */}
                <div className="w-20 h-20 bg-foreground/5 border border-foreground/10 rounded-full flex flex-col items-center justify-center mb-8 relative z-10 group-hover:bg-orange-600 transition-all duration-500 group-hover:scale-110 shadow-2xl">
                  <span className="text-[10px] font-black text-foreground opacity-50 group-hover:opacity-100 group-hover:text-white mb-1 leading-none">{item.date.split(' ')[2]}</span>
                  <div className="w-2 h-2 bg-orange-500 rounded-full group-hover:bg-white animate-pulse"></div>
                </div>

                <div className="mb-4">
                  <span className="text-orange-500 font-black text-[10px] uppercase tracking-widest mb-2 block">{item.date}</span>
                  <h4 className="text-xl font-extrabold text-foreground tracking-tight group-hover:text-orange-500 transition-colors">{item.title}</h4>
                </div>
                <p className="text-slate-500 text-xs leading-relaxed max-w-xs">{item.desc}</p>
                
                {/* Visual Connector for Mobile */}
                <div className="w-[1px] h-12 bg-foreground/5 mt-8 lg:hidden"></div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
